module.exports = __webpack_public_path__ + "img/logo.c3e93734.png";